module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0153.jpg?v=68198b9a";